import React from "react";

export function Message({
  className,
  children,
  severity = "info",
}: {
  children: React.ReactNode;
  severity?: "error" | "warning" | "info" | "success";
  className?: string;
}) {
  let bgColor = "bg-blue-100 text-blue-800";
  if (severity === "error") {
    bgColor = "bg-red-100 text-red-800";
  } else if (severity === "warning") {
    bgColor = "bg-yellow-100 text-yellow-800";
  } else if (severity === "success") {
    bgColor = "bg-green-100 text-green-800";
  }

  return (
    <div
      className={`p-4 rounded-md border ${bgColor} ${className || ""}`}
      role="alert"
    >
      {children}
    </div>
  );
}
